import { useQuery } from '@tanstack/react-query';
import type { ApiError } from '../api';
import { connectEndpoints } from '../api-connect';
import { NotPermitted } from '../App';
import { StripeAccountCard } from '../components/StripeAccountCard';
import { usePermissions } from '../session';
import { ErrorNote } from '../ui';

/**
 * Admin → Settings → Payments (Stripe Connect P2, D-393; plan §3.3).
 *
 * The team's own Stripe account: whether it can take payments and be paid
 * out, what Stripe still needs, and the way back into Stripe's onboarding.
 * The team's admin can start and continue onboarding here (the owner's
 * answer 15); STGD staff do the same from the STGD section.
 *
 * Nothing about STGD's platform key is shown or settable here, and it is not
 * in Integrations either: it is a Worker secret only STGD sets (D-391).
 */
export default function PaymentsPage() {
  const can = usePermissions();
  const view = useQuery({ queryKey: ['stripe-account'], queryFn: connectEndpoints.account, enabled: can('payments.stripe_account.view') });
  if (!can('settings.manage')) return <NotPermitted permission="settings.manage" />;
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-ink-900">Payments</h1>
        <p className="mt-1 text-sm text-ink-600">The team’s Stripe account, connected to STGD. Card payments are made on it, refunds and chargebacks come out of it, and Stripe pays it out on the schedule set in its own Dashboard.</p>
      </div>
      {!can('payments.stripe_account.view') ? <NotPermitted permission="payments.stripe_account.view" /> : view.error ? <ErrorNote>{(view.error as ApiError).message}</ErrorNote> : <StripeAccountCard door="settings" view={view.data} queryKey={['stripe-account']} />}
    </div>
  );
}
